// src/lang/en-US.js
export default {
    navbar: {
        home: "Home",
        productCenter: "Product Center",
        productAttachment: "Attachment",
        industryApplications: "Industry Applications",
        newsEvents: "News & Events",
        serviceRepair: "Service & Repair",
        aboutUs: "About Us",
        contactUs: "Contact Us",
        shoppingMall: "Shopping Mall",
        order: "Order",
        login: "Login"
    },
    footer: {
        innaChina: "INNA China",
        address: "Address: No. 11, Optics Valley South Road, Jinpu New Area, Dalian, Liaoning",
        fax: "Fax: +86 411 88035448",
        phone: "Tel: +86 411 88035458",
        email: "Email: http://info@innaspindle.com",
        copyright: "Note: (Copyright © 2025 INNA电主轴官网 辽ICP备19020774号-1)",
        security: "Note: (辽公网安备21021702000669)",
        miniProgram: "Mini Program",
        enterpriseWeChat: "Enterprise WeChat"
    },
    mobileMenu: {
        productCenter: "Product Center",
        industryApplications: "Industry Applications",
        newsEvents: "News & Events",
        serviceRepair: "Service & Repair",
        aboutUs: "About Us",
        contactUs: "Contact Us",
        shoppingMall: "Shopping Mall"
    },
    langSwitch: {
        chinese: "中文",
        english: "English"
    },
    "转速": "Speed",
    "扭矩": "Torque",
    "功率": "Power",
    "Rotational speed": "Speed",
    "Torque": "Torque",
    "Power": "Power",
    chart: {
        torqueTitle: "Torque Curve",
        powerTitle: "Power Curve",
        speedAxis: "Speed (rpm)",
        torqueAxis: "Torque (N·m)",
        powerAxis: "Power (kW)",
        seriesPlaceholder: "Product",
        dataError: "Data Error",
        unknownCategory: "Unknown Category",
        selected: "Selected",
        unselected: "Unselected",
        value: "Value",
        status: "Status"
    }

    ,home: {
        reasonTitle: 'Four Reasons to Choose INNA',
        reasonTitleTranslation: ' four major reasons',
        reasonDesc: 'We strive for perfect quality, developing and manufacturing high-tech products with significant added value for customers',
        coreProductTitle: 'Core Products ',
        coreProductRequirement: '· Precisely Matching Industrial Needs',
        coreProductDesc: 'We produce all core components ourselves to manage the manufacturing process and control production quality',
        industryTitle: 'Perfect Rotation Covering ',
        industryRequirement: 'All Industries',
        industryDesc: 'From micro-processing to heavy machine tool cutting, INNA electric spindles provide reliable power support for various fields',
        newsTitle: 'News ',
        activityTitle: '& Events',
        newsDesc: 'From micro-processing to heavy machine tool cutting, INNA electric spindles provide reliable power support for various fields',
        contactTitle: 'Contact ',
        we: 'Us',
        moreProduct: 'More Products',
        viewDetail: 'View Details',
        learnMore: 'Learn More>>',
        submit: 'Submit',
        form: {
            companyName: 'Company Name',
            industry: 'Industry',
            contactName: 'Contact Person',
            phoneNumber: 'Phone Number',
            workEmail: 'Work Email',
            cooperationDemand: 'Cooperation Demand',
            region: 'Region',
            placeholder: {
                companyName: 'Please enter company name',
                industry: 'Please enter industry',
                contactName: 'Please enter contact person',
                phoneNumber: 'Please enter phone number',
                workEmail: 'Please enter work email',
                cooperationDemand: 'Please enter cooperation demand',
                region: 'Please Select region',
            },
            message: {
                required: 'Please enter {field}',
                companyNameLength: 'Company name length must be between 2 and 100 characters',
                industryLength: 'Industry name length must be between 2 and 50 characters',
                contactNameLength: 'Contact person length must be between 2 and 20 characters',
                phoneNumberValid: 'Please enter a valid phone number',
                emailValid: 'Please enter a valid email address',
                demandLength: 'Cooperation demand length must be between 10 and 500 characters'
            }
        },
        message: {
            submitSuccess: 'Submission successful!',
            submitError: 'Please fill in the correct information!'
        }
    },
    reasons: [
        {
            title: 'High-Precision Bearing Technology',
            description1: 'Precision bearing technology',
            description2: 'Service life increased by 300%'
        },
        {
            title: 'High-Speed Stable Operation',
            description1: 'Maximum speed 90,000rpm',
            description2: 'Temperature rise ≤15℃'
        },
        {
            title: 'Intelligent Cooling System',
            description1: 'Oil-water dual circulation cooling system',
            description2: '24/7 continuous operation without overheating risk'
        },
        {
            title: 'Customized Solutions',
            description1: 'For aerospace, medical, 3C and other industries',
            description2: 'Provide exclusive spindle solutions'
        }
    ],items: {
        highPrecision: {
            title: 'High-Precision Bearing Technology',
            desc1: 'Precision bearing technology',
            desc2: 'Service life increased by 300%'
        },
        highSpeed: {
            title: 'High-Speed Stable Operation',
            desc1: 'Maximum speed 90,000rpm',
            desc2: 'Temperature rise ≤15℃'
        },
        coolingSystem: {
            title: 'Intelligent Cooling System',
            desc1: 'Oil-water dual circulation cooling system',
            desc2: '24/7 continuous operation without overheating risk'
        },
        customized: {
            title: 'Customized Solutions',
            desc1: 'For aerospace, medical, 3C and other industries',
            desc2: 'Provide exclusive spindle solutions'
        }
    },
    aboutUs: {
        title: "About Us",
        companyIntro: {
            prompt: "Company Introduction",
            title: "Who",
            titleHighlight: " Are We?"
        },
        techIntro: {
            prompt: "Technical Introduction",
            title: "Our",
            titleHighlight: " Capabilities"
        },
        serviceFields: {
            subtitle: "Main Service Areas",
            title: "Capabilities Covering",
            titleHighlight: " All Fields"
        }
    },orderTable:{
        orderList:{
            name:'OrderList',
            receivingInfo:'Recipient Information',
            note:'Note',
            createTime:'Order/Payment Time',
            coupon:'Coupon',
            amountTo:'Total',
            orderNumber:'Order Number / Action',
            copySuccess:'Copy successful!',
            noOrderId: 'no Order',
            delivery: 'Delivery successful',
            totalQuantity:'Total Quantity',
            actualPayment:'Actual Payment'
        },
        emptyText: 'No Data'
    },orderDetail:{
        receipt: 'Confirm receipt',
        pageTitle:'Order Details',
        invoice:'Invoice',
        viewInvoice:'View Invoice',
        pendingPayment:'Pending Payment',
        orderNumber:'Order Number',
        payNow:'Pay Now',
        orderProgress:'Order Progress',
        buyerOrder:'Buyer Places Order',
        buyerPayment:'Buyer Payment',
        merchantShip:'Merchant Ships',
        buyerReceive:'Buyer Receives',
        orderInfo:'Order Information',
        orderNumberLabel:'Order Number:',
        orderTime:'Order Time:',
        userName:'User Name:',
        userPhone:'User Phone:',
        paymentMethod:'Payment Method:',
        wechatPay:'WeChat Pay',
        paymentTime:'Payment Time:',
        orderStatus:'Order Status:',
        receivingInfo:'Receiving Information',
        receiver:'Receiver:',
        contactPhone:'Contact Phone:',
        receivingAddress:'Receiving Address:',
        detailAddress:'Detail Address:',
        productInfo:'Product Information',
        productImage:'Product Image',
        productName:'Product Name',
        productCategory:'Product Category',
        addTime:'Add Time',
        operation:'Operation',
        view:'View',
        quantity:'Quantity',
        attribute:'Attribute',
        productTotalPrice:'Product Total Price:',
        payableAmount:'Payable Amount:',
        orderTotal:'Order Total:',
        logisticsInfo:'Logistics Information',
        noLogisticsInfo:'No logistics information available, please complete payment first',
        viewTitle:'View',
        cancel:'Cancel',
        submit:'Submit',
        invoiceInfo:'Invoice Information',
        invoiceTitle:'Invoice',
        invoiceTitleType:'Invoice Title Type',
        pleaseSelect:'Please Select',
        personal:'Personal',
        nonEnterprise:'Non-Enterprise',
        enterprise:'Enterprise',
        buyer:'Buyer',
        buyerTaxNo:'Buyer Tax No.',
        remark:'Remark',
        invoiceDownload:'Invoice',
        invoiceLabel:'Invoice',
        close:'Close',
        backToList:'Back to List',
        orderStatusList:{
            pendingPayment:'Pending Payment',
            pendingShip:'Pending Shipment',
            shipped:'Shipped',
            completed:'Completed',
            closed:'Closed'
        },
        messages:{
            noInvoiceRecord:'No invoice record available, please wait',
            selectInvoiceTitleType:'Please select invoice title type',
            fillBuyerTaxNo:'Please fill in buyer tax number',
            fillBuyerName:'Please fill in buyer name',
            submitSuccess:'Submission successful',
            confirmDownload:'Are you sure you want to download this invoice ?',
            downloadCancelled:'Download cancelled'
        }
    },userInfo:{
        basicInfo:'Basic Information',
        clickUpload:'Click to Upload',
        account:'Account',
        notSet:'Not Set',
        gender:'Gender',
        pleaseSelectGender:'Please Select Gender',
        birthday:'Birthday',
        securitySettings:'Security Settings',
        bindPhone:'Bind Phone',
        bindEmail:'Bind Email',
        addressInfo:'Address Information',
        countryRegion:'Country/Region',
        pleaseSelect:'Please Select',
        province:'Province',
        city:'City',
        saveInfo:'Save Information',
        receivingAddress:'Receiving Address',
        logout:'Logout',
        bindPhoneTitle:'Bind Phone',
        enterPhone:'Please Enter Phone Number',
        enterCode:'Please Enter Verification Code',
        getCode:'Get Verification Code',
        bindNow:'Bind Now',
        genderOption:{
            unknown:'Unknown',
            male:'Male',
            female:'Female'
        },
        messages:{
            uploadAvatarJPGOnly:'Avatar image can only be JPG format!',
            uploadAvatarSizeLimit:'Avatar image size cannot exceed 2MB!',
            saveSuccess:'Save successful',
            enterCorrectPhone:'Please enter a correct phone number',
            phoneValidateFailed:'Phone number validation failed',
            codeSent:'Verification code sent, please check',
            codeSendFailed:'Failed to send verification code',
            bindSuccess:'Binding successful',
            bindFailed:'Binding failed',
            bindFailedRetry:'Binding failed, please try again later',
            confirmLogout:'Are you sure you want to logout?',
            confirm:'Confirm',
            cancel:'Cancel',
            logoutSuccess:'Logout successful',
            logoutCancelled:'Logout cancelled'
        }
    },receivingAddress:{
        pageTitle:'Receiving Address',
        add:'Add',
        operation:'Operation',
        edit:'Edit',
        delete:'Delete',
        yes:'Yes',
        no:'No',
        addTitle:'Add Receiving Address',
        editTitle:'Edit Receiving Address',
        receiver:'Receiver',
        phone:'Phone Number',
        area:'Area',
        detailAddress:'Detail Address',
        postCode:'Postal Code',
        defaultAddress:'Default Address',
        enterReceiverName:'Please Enter Receiver Name',
        enterPhone:'Please Enter 11-digit Phone Number',
        selectArea:'Please Select Province/City/District',
        enterDetailAddress:'Please Enter Street, House Number and Other Details',
        enterPostCode:'Please Enter Postal Code (Optional)',
        confirm:'Confirm',
        cancel:'Cancel',
        tableColumns:{
            receiver:'Receiver',
            phone:'Phone',
            area:'Area',
            detailAddress:'Detail Address',
            postCode:'Postal Code',
            isDefault:'Is Default'
        },
        messages:{
            confirmDelete:'Are you sure you want to delete this receiving address?',
            deleteSuccess:'Delete successful',
            editSuccess:'Edit successful',
            addSuccess:'Add successful',
            titleRequired:'Title cannot be empty'
        }
    },
    shoppingMall: {
        buy: "Buy Now",
    },
    waresDetails: {
        loading: "Loading...",
        thumbnailAlt: "Product Thumbnail",
        taxIncludedPrice: "Tax Included Price",
        yuan: "Yuan",
        sold: "Sold",
        quantity: "Quantity",
        buyNow: "Buy Now",
        service: "Customer Service",
        friendlyTip: "Friendly Tip: ",
        friendlyTipContent: "Placing orders through the platform can help you reduce potential risks in the transaction process. Keep your funds safe and trade with peace of mind.",
        detail: "Details",
        productParameters: "Product Parameters"
    },
    payShopp: {
        sale: 'Your sales engineer',
        receivingAddress: "Receiving Address",
        selectAddress: "Select Address",
        default: "Default",
        pleaseAddAddress: "Please Add Receiving Address",
        productImage: "Product Image",
        productId: "Product ID: ",
        stock: "Stock: ",
        selectSpec: "Select Specification",
        selectedSpec: "Selected Specification:",
        purchaseQuantity: "Purchase Quantity",
        orderNote: "Order Note",
        notePlaceholder: "Please enter note (optional)",
        total: "Total: ",
        brand: "brand: ",
        unit: "unit: ",
        weight: "weight: ",
        Specifications: "Specifications: ",
        FriendlyReminder: "Friendly Reminder: ",
        buyNow: "Buy Now",
        messages: {
            pleaseAddAddress: "Please add receiving address",
            pleaseSelectCompleteSpec: "Please select complete specification",
            stockInsufficient: "Insufficient stock for this product",
            createOrderFailed: "Failed to create order!",
            paySuccess: "Payment successful!"
        }
    },
    serviceRepair: {
        localContact: "Local Service and Repair Contact Information",
        phone: "Phone: ",
        email: "Email: ",
        repairRegistration: "Spindle Repair Registration",
        supplementaryExplanation: "Supplementary Explanation",
        supplementaryExplanationContent: "When you send the spindle back to INNA, if possible, please use the original spindle shipping box. If not possible, it is recommended to pack and send the spindle in the best and most stable way. INNA is not responsible for the loss, theft or damage of spindle goods.",
        send: "Send",
        messages: {
            sendSuccess: "Send successful!",
            pleaseEnter: "Please enter",
            pleaseSelect: "Please select"
        }
    },
    product: {
        diameter: 'Diameter',
        maximumSpeed: 'Maximum Speed',
        proInterface: 'Interface',
        bearingLubrication: 'Bearing Lubrication',
        proPower: 'Power S1',
        proTorque: 'Torque S1',
        productList: 'Product List'
    },
    spindleEmpty: {
        title: 'Products ({count})',
        subtitle: 'Please select spindles to compare',
        description: 'To view spindle details, please make selections in the performance chart.',
        tipMulti: 'Drag upward to select multiple spindles at once',
        tipSingle: 'Click a single dot to choose one spindle',
        tipFilter: 'Click the X axis to filter by tool interface type'
    },
    compare : 'compare',
    cancel : 'cancel',
    details : 'details',
    detailView: 'View Details',
    pdfPreview: 'PDF Preview',
    close: 'Close',
    CompareProductParameters: 'Compare product parameters',
    productCompared: {
        model: 'Model',
        type: 'Type',
        diameter: 'Diameter(mm)',
        maximumSpeed: 'Maximum Speed(rev/min)',
        minimumSpeed: 'Minimum Speed(rev/min)',
        proInterface: 'Interface',
        bearingLubrication: 'Bearing Lubrication',
        proPower: 'Power S1',
        proTorque: 'Torque S1',
        maxPowerS1: 'Max Power S1 (kW)',
        minPowerS1: 'Min Power S1 (kW)',
        maxTorqueS1: 'Max Torque S1 (Nm)',
        minTorqueS1: 'Min Torque S1 (Nm)'
    },
    TechnicalData: 'Technical data',
    RatedData: 'Rated Data',
    back: 'return',
    message: {
        select: 'Please Select ',
        required: 'Please enter ',
        minLength: 'length must be at least 2 characters ',
        maxLength: 'length cannot exceed 100 characters ',
        validPhone: 'Please enter a valid phone number ',
        validEmail: 'Please enter a valid email address' ,
    },
    field: {
        companyName: 'Company Name',
        industry: 'Industry',
        contactName: 'Contact Person',
        phoneNumber: 'Phone Number',
        workEmail: 'Work Email',
        cooperationDemand: 'Cooperation Demand',
        region: 'Region',
    },
    upload: 'upload',
    walksLife: {
        relatedImages: 'Download'
    },
    loading: 'Loading...',
    login: {
        expiredMessage: 'Your login has expired or you are not logged in, please log in again',
        expiredTitle: 'Login Expired'
    },
};
